import { memo, useEffect, useRef } from 'react'

const DELAY_MS_DEFAULT = 60_000

interface TimeoutTriggerProps {
  onTimeout: () => void
}

const TimeoutTrigger = ({ onTimeout }: TimeoutTriggerProps) => {
  const timeoutIdRef = useRef<number | null>(null)
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (timeoutIdRef.current !== null) return

    timeoutIdRef.current = window.setTimeout(() => {
      if (!hasFiredRef.current) {
        hasFiredRef.current = true
        try {
          onTimeout()
        } catch {
          // optionally log
        }
      }
    }, DELAY_MS_DEFAULT)

    return () => {
      if (timeoutIdRef.current !== null) {
        clearTimeout(timeoutIdRef.current)
        timeoutIdRef.current = null
      }
    }
  }, [onTimeout])

  return null
}

export default memo(TimeoutTrigger)
